module.exports = __webpack_public_path__ + "static/img/user-avatar.d8a976bb.png";